(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/iam-idp/assets/javascripts/utils/login.js') >= 0) return;  svs.modules.push('/modules/iam-idp/assets/javascripts/utils/login.js');

'use strict';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const url = svs.utils.url;
const {
  Events,
  ErrorTypes,
  LoginMethods,
  BankidStatus
} = svs.accountservices.authenticate.definitions;
const {
  isPollingAtom,
  qrCodeAtom,
  showLoaderAtom,
  loginCompletedAtom,
  isNewCustomerAtom,
  activeMethodAtom
} = svs.iam_idp.atoms;
const {
  getDefaultStore
} = jotai;
const store = getDefaultStore();
const {
  logger
} = svs.iam_idp;
const {
  postMessageToParent,
  updateParentQuerystring,
  parentTrackEvent
} = svs.iam_idp.utils;
const {
  POST_MESSAGE_TYPES
} = svs.iam_idp.constants;
let {
  lm: shouldResumePending
} = url.queryString;
const {
  setLoginMethodInDeviceSession
} = svs.iam_idp.utils;
class Login {
  constructor() {
    var _svs$iam_idp;
    let isDesktop = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    this.isDesktop = isDesktop;
    this.qrCode = false;
    this.isQRMode = false;
    this.shouldResumeLogin = false;
    this.parentQsUpdated = false;
    this.iamAppReturnUrl = '';

    if ((_svs$iam_idp = svs.iam_idp) !== null && _svs$iam_idp !== void 0 && (_svs$iam_idp = _svs$iam_idp.utils) !== null && _svs$iam_idp !== void 0 && _svs$iam_idp.setupDialogListener) {
      svs.iam_idp.utils.setupDialogListener(this);
    }
    svs.accountservices.authenticate.login.on(Events.NEW_CUSTOMER, response => this.onNewCustomerLogin(response));
    svs.accountservices.authenticate.login.on(Events.ERROR, _ref => {
      let {
        type,
        message
      } = _ref;
      return this.handleError({
        type,
        message
      });
    });
    svs.accountservices.authenticate.login.on(Events.LOGIN, _ref2 => {
      let {
        lastLoginTime,
        firstName,
        response
      } = _ref2;
      return this.onLogin(lastLoginTime, firstName, response);
    });
    svs.accountservices.authenticate.login.on(Events.READY_TO_POLL, activeProcess => this.onReadyToPoll(activeProcess));
    svs.accountservices.authenticate.login.on(Events.CANCELLED, _ref3 => {
      let {
        isBankID
      } = _ref3;
      return this.onCanceled(isBankID);
    });
    svs.accountservices.authenticate.login.on(Events.TIMEOUT_TYPE_UPDATED, _ref4 => {
      let {
        pollStatus
      } = _ref4;
      return this.onTimeoutType(pollStatus);
    });
    svs.accountservices.authenticate.login.on(Events.QR_UPDATE, qr => this.updateQR(qr));
    svs.accountservices.authenticate.login.on(Events.UPDATE_PARENT_URL, async _ref5 => {
      let {
        queryData,
        clearUrlParams
      } = _ref5;
      if (clearUrlParams) {
        return;
      }
      this.iamAppReturnUrl = await updateParentQuerystring(queryData);
      this.parentQsUpdated = true;
    });
    if (shouldResumePending) {
      svs.accountservices.authenticate.login.resumePendingLogin(true);
    }
  }
  blockNavigation() {
    this.isBlocked = true;
  }
  unblockNavigation() {
    this.isBlocked = false;
  }
  updateQR(qr) {
    this.qrCode = qr;
    store.set(qrCodeAtom, qr);
  }
  onTimeoutType(pollStatus) {
    if (this.qrCode && pollStatus === BankidStatus.DELIVERED_TO_MOBILE) {
      store.set(showLoaderAtom, true);
    }
  }
  async onNewCustomerLogin(response) {
    var _store$get;
    store.set(loginCompletedAtom, true);
    const isFreja = ((_store$get = store.get(activeMethodAtom)) === null || _store$get === void 0 ? void 0 : _store$get.isFreja) || false;
    try {
      var _svs$components$Stora;
      postMessageToParent({
        value: isFreja ? 'FREJA_EID' : 'BANKID',
        type: POST_MESSAGE_TYPES.SET_LOGIN_TYPE
      });
      const returnUrl = url.queryString.returnUrl;
      if (returnUrl) {
        response.returnUrl = returnUrl;
      }
      const {
        getIAMData
      } = svs.iam_idp.utils;
      const {
        redirect_uri,
        state
      } = await getIAMData();
      const {
        progressStatus,
        jwt,
        iamCode: code
      } = response;
      const iamUrl = "".concat(redirect_uri, "?state=").concat(state, "&code=").concat(code || jwt);
      response.depositValue = (_svs$components$Stora = svs.components.Storage) === null || _svs$components$Stora === void 0 || (_svs$components$Stora = _svs$components$Stora.browser) === null || _svs$components$Stora === void 0 || (_svs$components$Stora = _svs$components$Stora.get('depositValues', 'quick-deposit')) === null || _svs$components$Stora === void 0 ? void 0 : _svs$components$Stora.amount;
      const newCustomerEvent = {
        category: 'Users',
        action: 'Customer Registration'
      };
      const labelExtra = isFreja ? '_freja' : '_bankid';
      if (progressStatus === 20) {
        newCustomerEvent.opt_label = "started_new_customer".concat(labelExtra);
      } else if (progressStatus === 21) {
        newCustomerEvent.opt_label = "started_retail_customer".concat(labelExtra);
      } else if (progressStatus === 22) {
        newCustomerEvent.opt_label = "started_reactivated_customer".concat(labelExtra);
      }
      await parentTrackEvent(newCustomerEvent);
      postMessageToParent({
        type: POST_MESSAGE_TYPES.FULLSCREEN
      });
      svs.utils.form.postToUrl(svs.core.urlMapping.get('iamPlayerRegistration') || '/iam-registration', _objectSpread(_objectSpread({}, response), {}, {
        iamUrl
      }), 'POST');
    } catch (e) {
      this.onLogin();
    }
  }
  async startBankIdSameDevice(isNewCustomer) {
    this.blockNavigation();
    this.isNewCustomer = isNewCustomer;
    this.isQRMode = false;
    let codeChallenge;
    let codeChallengeMethod;
    try {
      const searchParams = new URLSearchParams(window.location.search);
      codeChallenge = searchParams.get('lcc');
      codeChallengeMethod = searchParams.get('lcm');
    } catch (e) {
      logger.info('Could not extract code challenge from parent URL');
    }
    const {
      getIAMData
    } = svs.iam_idp.utils;
    const {
      nonce,
      clientId
    } = await getIAMData();
    if (nonce) {
      if (clientId) {
        logger.info("Has found nonce: ".concat(nonce, " and clientId: ").concat(clientId));
      } else {
        logger.warn('Has found nonce but not clientId');
      }
    } else if (clientId) {
      logger.warn('Has found clientId but not nonce');
    }
    svs.accountservices.authenticate.login.start({
      method: LoginMethods.BANKID,
      codeChallenge,
      codeChallengeMethod,
      isCustomerRegistration: isNewCustomer,
      isPoker: false,
      nonce,
      clientId,
      qr: false,
      isIam: true
    });
  }
  async onLogin(_lastLoginTime, _firstName, response) {
    var _store$get2;
    logger.debug('IAM logged in');
    this.unblockNavigation();
    store.set(loginCompletedAtom, true);
    const isFreja = ((_store$get2 = store.get(activeMethodAtom)) === null || _store$get2 === void 0 ? void 0 : _store$get2.isFreja) || false;
    const {
      getIAMData
    } = svs.iam_idp.utils;
    const {
      redirect_uri,
      state
    } = await getIAMData();
    const {
      code,
      jwt
    } = response || {};
    postMessageToParent({
      value: isFreja ? 'FREJA_EID' : 'BANKID',
      type: POST_MESSAGE_TYPES.SET_LOGIN_TYPE
    });
    const successEvent = {
      category: 'Users',
      action: 'Eid Success',
      opt_label: "Janssen-".concat(isFreja ? 'freja' : 'bankid')
    };
    if (!redirect_uri || !state) {
      const messageParts = [];
      if (!redirect_uri) {
        messageParts.push('redirect_uri is missing');
      }
      if (!state) {
        messageParts.push('state is missing');
      }
      const message = "Missing IAM Data after BankId: ".concat(messageParts.join(', '));
      logger.info(message);
      this.handleError({
        type: ErrorTypes.INVALID_TOKEN
      });
      await parentTrackEvent(successEvent);
      window.location.href = "".concat(redirect_uri, "?state=").concat(state, "&code=").concat(code || jwt);
    } else {
      const message = 'Missing code/jwt in IAM login response';
      logger.error(message, response);
      this.handleError({
        type: ErrorTypes.INVALID_TOKEN
      });
    }
  }
  async onReadyToPoll() {
    svs.accountservices.authenticate.login.poll();
    store.set(isPollingAtom, true);
    if (!shouldResumePending && !this.isQRMode) {
      await this.waitForParentQsUpdate();
      const url = svs.accountservices.authenticate.login.getAppUrl(this.iamAppReturnUrl);
      postMessageToParent({
        value: url,
        type: POST_MESSAGE_TYPES.PARENT_REDIRECT
      });
    }
    if (store.get(activeMethodAtom).isFreja) {
      this.updateQR(svs.accountservices.authenticate.login.getAppUrl());
    }
  }
  waitForParentQsUpdate() {
    if (this.parentQsUpdated) {
      return Promise.resolve();
    }

    return new Promise(resolve => {
      const maxWaitTime = 5000; 
      const checkInterval = 50; 
      const startTime = Date.now();
      const checkUpdate = () => {
        if (this.parentQsUpdated) {
          resolve();
        } else if (Date.now() - startTime > maxWaitTime) {
          logger.warn('Timeout waiting for parent querystring update');
          resolve(); 
        } else {
          setTimeout(checkUpdate, checkInterval);
        }
      };
      checkUpdate();
    });
  }
  onCanceled() {
    store.set(isPollingAtom, false);
    store.set(showLoaderAtom, false);
    shouldResumePending = false;
    this.qrCode = false;
    this.unblockNavigation();
  }
  async start(isNewCustomer) {
    store.set(loginCompletedAtom, false);
    this.blockNavigation();
    this.isNewCustomer = isNewCustomer;
    let codeChallenge;
    let codeChallengeMethod;
    this.isQRMode = this.isDesktop;
    try {
      const searchParams = new URLSearchParams(window.location.search);
      codeChallenge = searchParams.get('lcc');
      codeChallengeMethod = searchParams.get('lcm');
    } catch (e) {
      logger.info('Could not extract code challenge from parent URL');
    }
    const method = store.get(activeMethodAtom).isFreja ? LoginMethods.FREJA : LoginMethods.BANKID;
    await setLoginMethodInDeviceSession(store.get(activeMethodAtom).isFreja ? 'FREJA_EID' : 'BANKID');
    const {
      getIAMData
    } = svs.iam_idp.utils;
    const {
      nonce,
      clientId
    } = await getIAMData();
    if (nonce) {
      if (clientId) {
        logger.info("Has found nonce: ".concat(nonce, " and clientId: ").concat(clientId));
      } else {
        logger.warn('Has found nonce but not clientId');
      }
    } else if (clientId) {
      logger.warn('Has found clientId but not nonce');
    }
    svs.accountservices.authenticate.login.start({
      method,
      codeChallenge,
      codeChallengeMethod,
      isCustomerRegistration: isNewCustomer,
      isPoker: false,
      nonce,
      clientId,
      qr: this.isDesktop,
      isIam: true
    });
  }
  async handleError(err) {
    var _store$get3;
    logger.warn("Failed to log in user with Error type: ".concat((err === null || err === void 0 ? void 0 : err.type) || 'No type recived', " code: ").concat(err === null || err === void 0 ? void 0 : err.code), err === null || err === void 0 ? void 0 : err.message);
    const isFreja = ((_store$get3 = store.get(activeMethodAtom)) === null || _store$get3 === void 0 ? void 0 : _store$get3.isFreja) || false;
    svs.accountservices.authenticate.login.cancel();
    store.set(isPollingAtom, false);
    store.set(showLoaderAtom, false);
    store.set(loginCompletedAtom, false);
    shouldResumePending = false;
    this.unblockNavigation();
    const trackFailureEvent = {
      category: 'Users',
      action: 'Eid Failure',
      opt_label: "Janssen-".concat(isFreja ? 'freja' : 'bankid'),
      opt_value: (err === null || err === void 0 ? void 0 : err.code) || 665
    };
    const dialog = {};
    await parentTrackEvent(trackFailureEvent);
    const msgKonto = 'För att spela hos AB Svenska Spel behöver du skapa ett spelkonto.';
    const msgEid = 'För att skapa spelkonto med Freja eId så krävs Freja eId+. Du kommer därför att behöva identifiera dig igen.';
    switch (err === null || err === void 0 ? void 0 : err.type) {
      case ErrorTypes.FREJA_NEW_CUSTOMER:
        this.isNewCustomer = true;
        store.set(isNewCustomerAtom, true);
        dialog.title = 'Skapa spelkonto';
        dialog.message = "".concat(msgKonto, "\n").concat(msgEid);
        break;
      case ErrorTypes.INVALID_TOKEN:
        dialog.title = 'Misslyckad inloggning';
        dialog.message = 'Det går inte att logga in just nu, var vänlig försök igen lite senare.';
        break;
      case ErrorTypes.LOGIN_USER_ABORTED:
        dialog.title = 'Inloggning avbruten';
        dialog.message = 'Du har avbrutit din inloggning';
        break;
      case ErrorTypes.CANNOT_CANCEL:
      default:
        dialog.title = 'Misslyckad inloggning';
        dialog.message = 'Ett fel har uppstått när du försökte logga in.';
        break;
    }
    postMessageToParent({
      type: POST_MESSAGE_TYPES.SHOW_DIALOG,
      title: dialog.title,
      message: dialog.message
    });
  }
  destroy() {
    svs.accountservices.authenticate.login.off(Events.NEW_CUSTOMER);
    svs.accountservices.authenticate.login.off(Events.ERROR);
    svs.accountservices.authenticate.login.off(Events.LOGIN);
    svs.accountservices.authenticate.login.off(Events.READY_TO_POLL);
    svs.accountservices.authenticate.login.off(Events.CANCELLED);
    svs.accountservices.authenticate.login.off(Events.QR_UPDATE);
    svs.accountservices.authenticate.login.off(Events.UPDATE_PARENT_URL);
    this.unblockNavigation();
  }
}
svs.iam_idp.utils.Login = new Login(!svs.core.detect.formfactor.mobile());

 })(window);